import { FC } from 'react';
import Image from 'next/image';
import { IMainMenuMobile } from '@modules/header/domain/models/menu.model';
import { itemListAnimation } from '../mainMenu/MainMenuMobile.animate';
import { ItemList, MenuArrowIcon, MenuImgWrapper, MenuText, WrapperItemList } from './MenuTitleMobile.style';
interface Props {
  menu: IMainMenuMobile;
  onClick: () => void;
}
const MenuTitleMobileWithList: FC<Props> = ({
  menu,
  onClick
}: Props) => {
  return <ItemList variants={itemListAnimation} onClick={onClick}>
            <WrapperItemList>
                <MenuImgWrapper>
                    <Image src={menu.iconImgUrl} alt={menu.title} width={24} height={24} />
                </MenuImgWrapper>
                <MenuText>{menu.title}</MenuText>
                <MenuArrowIcon src="/icons/arrow-right-gray.svg" alt="arrow right" width={20} height={20} />
            </WrapperItemList>
        </ItemList>;
};
export default MenuTitleMobileWithList;